export default {
  SET({commit}, payload) {
    commit('SET', payload)
  },
};